// Browsers drop tabs and line breaks from a URL, so "/\t/host" would become
// "//host": no control characters, spaces or backslashes at all.
const hasUnsafeCharacter = (value: string): boolean =>
  /[\s\\]/.test(value) || Array.from(value).some((char) => char.charCodeAt(0) < 0x20 || char.charCodeAt(0) === 0x7f);

/**
 * Where a link asks the app to go once signed in: a path in the app, never
 * another site ("//host" and "/\host" are other sites to a browser).
 */
export const safeNext = (next: string | null): string =>
  next && /^\/(?![/\\])/.test(next) && !hasUnsafeCharacter(next) ? next : '/dashboard';

/**
 * Where to go once signed in: the page that sent the person to sign in, or
 * else the `next` the link carried (an invitation, a group's entry).
 */
export const afterSignInPath = (location: { state?: unknown; search?: string }): string => {
  const from = (location.state as { from?: { pathname?: string; search?: string; hash?: string } } | null)?.from;
  if (from?.pathname) return `${from.pathname}${from.search ?? ''}${from.hash ?? ''}`;
  return safeNext(new URLSearchParams(location.search ?? '').get('next'));
};
